/**
 * @generated SignedSource<<2a8c6c19e087f13947cabd9a458c4e7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type noticeQuery$variables = Record<PropertyKey, never>;
export type noticeQuery$data = {
  readonly notice: {
    readonly contents: string | null | undefined;
    readonly result: boolean;
  };
};
export type noticeQuery = {
  response: noticeQuery$data;
  variables: noticeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NoticeOutput",
    "kind": "LinkedField",
    "name": "notice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contents",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "noticeQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "noticeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "45a90fdd05e260849d171e1d12c42bf4",
    "id": null,
    "metadata": {},
    "name": "noticeQuery",
    "operationKind": "query",
    "text": "query noticeQuery {\n  notice {\n    result\n    contents\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c3fea4fb650514485b90646e260f531";

export default node;
